import services from '@/config/services'

export default class PraticheService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche.url}` 
  }

  async getLiquidity(){
    let items = []
    const url = `${this.baseUrl}/graph/liquidity`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFatturatoPagamenti(){
    let items = []
    const url = `${this.baseUrl}/graph/fatturato-pagamenti`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getFatturatoPagamentiAcquisto(){
    let items = []
    const url = `${this.baseUrl}/graph/acquisto/fatturato-pagamenti`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getIva(){
    let items = []
    const url = `${this.baseUrl}/graph/iva`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }
  
  async getPods(){
    let items = []
    const url = `${this.baseUrl}/graph/get-pods`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPdrs(){
    let items = []
    const url = `${this.baseUrl}/graph/get-pdrs`

    try {
      let res =  await this.http.get(url)
      items = res.data
      return res.data;
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getPma(){
    let items = []
    const url = `${this.baseUrl}/graph/get-pma`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getConsumi(){
    let items = []
    const url = `${this.baseUrl}/graph/get-consumi`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getPun(){
    let items = []
    const url = `${this.baseUrl}/graph/get-pun`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPunGas(){
    let items = []
    const url = `${this.baseUrl}/graph/get-pun-gas`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getInfoCiclo(agentId, years){
    let items = []
    const url = `${this.baseUrl}/info-ciclo`

    try {
      let res =  await this.http.post(url, {agentId, years})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }



}
